import { render, staticRenderFns } from "./sixmark.vue?vue&type=template&id=5987a5c4&"
import script from "./sixmark.vue?vue&type=script&lang=js&"
export * from "./sixmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports